import Script from 'next/script';
import React from 'react';

export const BannerPrivacy = () => {
    return (
        <>
            <Script
                type="text/javascript"
                strategy="lazyOnload"
                async
                dangerouslySetInnerHTML={{
                    __html: `
                        var _iub = _iub || [];
                        _iub.csConfiguration = {
                            "lang": "en",
                            "siteId": 3284465,
                            "cookiePolicyId": 62323613,
                            "inlineDelay": 5000,
                            "banner": {
                                "position": "float-bottom-center",
                                "acceptButtonDisplay": true,
                                "applyStyles":false,
                                "customizeButtonDisplay": true,
                                "content": "We collect anonymous data we use for analytics and personalization (unless you fill out a contact form).",
                                slideDown: false,
                            },
                            "callback": {
                                onPreferenceExpressedOrNotNeeded: function(preference) {
                                    dataLayer.push({
                                        iubenda_ccpa_opted_out: _iub.cs.api.isCcpaOptedOut()
                                    });
                                    if (!preference) {
                                        dataLayer.push({
                                            event: "iubenda_preference_not_needed"
                                        });
                                    } else {
                                        if (preference.consent === true) {
                                            dataLayer.push({
                                                event: "iubenda_consent_given"
                                            });
                                            // added to get consent variable in gtm
                                            dataLayer.push({
                                               "iubenda_consent_given": true
                                            });
                                        } else if (preference.consent === false) {
                                            dataLayer.push({
                                                event: "iubenda_consent_rejected"
                                            });
                                        } else if (preference.purposes) {
                                            for (var purposeId in preference.purposes) {
                                                if (preference.purposes[purposeId]) {
                                                    dataLayer.push({
                                                        event: "iubenda_consent_given_purpose_" + purposeId
                                                    });
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        };
                    `,
                }}
            />
            <Script
                type="text/javascript"
                src="https://cdn.iubenda.com/cs/iubenda_cs.js"
                async
                strategy="lazyOnload"
            ></Script>
        </>
    );
};

export default BannerPrivacy;
